import { useAuth } from '@phx-husky/use-auth';

const useTranslations = () => {
    const auth = useAuth();
    const translate = (key, fallback, ...args) => auth.translate(key, fallback, ...args);
    return {
        translate,
    };
};

export { useTranslations };
